import React from "react";
import { Grid } from "@mui/material";

function FormCard({ children, ...props }) {
    return (
        <Grid
            container
            sx={{
                backgroundColor: "#ffffff",
                borderRadius: "16px",
                border: "2px solid #c6c6c6 !important",
                m: 1,
                p: { xs: 1, md: 3 },
                xs: 12,
            }}
            minHeight={20}
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            noValidate
            autoComplete="off"
            gap={2}
            {...props}
        >
            {children}
        </Grid>
    );
}

export default FormCard;
